import { ApiError, consentErrorSchema } from '../data-contract/error';
import { HTTPErrorWithResponseBody } from '../http-fetcher/http-error-with-response-body';

const isStatusCodeError =
    (status: number) =>
    (error: unknown): boolean =>
        (error instanceof ApiError && error.status === status) ||
        (error instanceof HTTPErrorWithResponseBody && error.response.status === status);

export const is400Error = isStatusCodeError(400);

export const is401Error = isStatusCodeError(401);

export const is403Error = isStatusCodeError(403);

export const is404Error = isStatusCodeError(404);

export const is500Error = isStatusCodeError(500);

export const isConsentError = (error: unknown): boolean =>
    (error instanceof ApiError && consentErrorSchema.safeParse(error).success) ||
    (error instanceof HTTPErrorWithResponseBody && consentErrorSchema.safeParse(error.body).success);

export const isNetworkError = (error: unknown): boolean => error instanceof TypeError;
